import TermsService from "@/components/consulting_teacher/modal/ConsultingTermsServiceModal.vue"
import SchoolAdd from "@/components/consulting_teacher/modal/ConsultingSchoolAddModal"
import BigSizeText from "@/components/consulting_teacher/modal/ConsultingBigSizeTextModal.vue"
export default {
    terms_service_view : TermsService,
    school_add : SchoolAdd,
    big_size_text : BigSizeText,
}